import * as ConsentUseCaseActions from './consent-use-case-actions';
import * as ConsentUseCaseReducer from './consent-use-case-reducer';

export {
    ConsentUseCaseActions,
    ConsentUseCaseReducer
};
